/**
 * @packageDocumentation
 * @module f1/is
 */

import { t_falsy } from '../types';

export interface IsFalsy {
  /**
   * Is falsy, which is not truthy; there are eight values:
   *
   * - `false`,	the keyword false
   * - `0`,	the number zero
   * - `-0`, the number negative zero
   * - `0n`, BigInt, when used as a boolean, follows the same rule as a Number. 0n is falsy.
   * - `""`, Empty string value
   * - `null`, the absence of any value
   * - `undefined`	the primitive value
   * - `NaN` not a number
   *
   * @public
   * @see f1.is.truthy
   * @function f1.is.falsy
   * @example
   *
   * ```ts
   * f1.is.falsy(false) => true
   * f1.is.falsy(0) => true
   * f1.is.falsy('') => true
   *
   * f1.is.falsy([]) => false
   * ```
   */
  <V>(value: V | t_falsy): value is t_falsy;
}

/**
 * @see IsFalsy
 */
export default <V>(value: V | t_falsy): value is t_falsy => {
  return !value;
};
